"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: ml/lending-risk-level.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fml%2Flending-risk-level.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.lendingRiskLevelToJSON = exports.lendingRiskLevelFromJSON = exports.LendingRiskLevel = void 0;
/* eslint-disable */
const protobufPackage = 'com.step.ml.common.proto';
var LendingRiskLevel;
(function (LendingRiskLevel) {
    LendingRiskLevel["INVALID_LENDING_RISK_LEVEL"] = "INVALID_LENDING_RISK_LEVEL";
    /**
     * LEVEL_DECLINE - Lending risk score below threshold -> Decline
     */
    LendingRiskLevel["LEVEL_DECLINE"] = "LEVEL_DECLINE";
    /**
     * LEVEL_ONE - Levels mapped to thresholds. Lower level indicates higher risk.
     * Indexed at ONE, and number of levels can grow.
     * E.g. LEVEL_ONE has higher risk than LEVEL_TWO.
     */
    LendingRiskLevel["LEVEL_ONE"] = "LEVEL_ONE";
    LendingRiskLevel["LEVEL_TWO"] = "LEVEL_TWO";
    LendingRiskLevel["LEVEL_THREE"] = "LEVEL_THREE";
    LendingRiskLevel["LEVEL_FOUR"] = "LEVEL_FOUR";
    LendingRiskLevel["LEVEL_FIVE"] = "LEVEL_FIVE";
    LendingRiskLevel["LEVEL_SIX"] = "LEVEL_SIX";
    LendingRiskLevel["UNRECOGNIZED"] = "UNRECOGNIZED";
})(LendingRiskLevel || (exports.LendingRiskLevel = LendingRiskLevel = {}));
function lendingRiskLevelFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_LENDING_RISK_LEVEL':
            return LendingRiskLevel.INVALID_LENDING_RISK_LEVEL;
        case 1:
        case 'LEVEL_DECLINE':
            return LendingRiskLevel.LEVEL_DECLINE;
        case 2:
        case 'LEVEL_ONE':
            return LendingRiskLevel.LEVEL_ONE;
        case 3:
        case 'LEVEL_TWO':
            return LendingRiskLevel.LEVEL_TWO;
        case 4:
        case 'LEVEL_THREE':
            return LendingRiskLevel.LEVEL_THREE;
        case 5:
        case 'LEVEL_FOUR':
            return LendingRiskLevel.LEVEL_FOUR;
        case 6:
        case 'LEVEL_FIVE':
            return LendingRiskLevel.LEVEL_FIVE;
        case 7:
        case 'LEVEL_SIX':
            return LendingRiskLevel.LEVEL_SIX;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return LendingRiskLevel.UNRECOGNIZED;
    }
}
exports.lendingRiskLevelFromJSON = lendingRiskLevelFromJSON;
function lendingRiskLevelToJSON(object) {
    switch (object) {
        case LendingRiskLevel.INVALID_LENDING_RISK_LEVEL:
            return 'INVALID_LENDING_RISK_LEVEL';
        case LendingRiskLevel.LEVEL_DECLINE:
            return 'LEVEL_DECLINE';
        case LendingRiskLevel.LEVEL_ONE:
            return 'LEVEL_ONE';
        case LendingRiskLevel.LEVEL_TWO:
            return 'LEVEL_TWO';
        case LendingRiskLevel.LEVEL_THREE:
            return 'LEVEL_THREE';
        case LendingRiskLevel.LEVEL_FOUR:
            return 'LEVEL_FOUR';
        case LendingRiskLevel.LEVEL_FIVE:
            return 'LEVEL_FIVE';
        case LendingRiskLevel.LEVEL_SIX:
            return 'LEVEL_SIX';
        case LendingRiskLevel.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.lendingRiskLevelToJSON = lendingRiskLevelToJSON;
//# sourceMappingURL=lending-risk-level.js.map